import React from 'react';
import { MapPin, Phone } from 'lucide-react';
import { Button } from '../ui/Button';
import { LocationData } from '../../data/locations';
interface LocationPageHeroProps {
  location: LocationData;
}
export function LocationPageHero({
  location
}: LocationPageHeroProps) {
  const scrollToContact = () => {
    const contactForm = document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20" data-id="element-504">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-505">
        <div className="max-w-3xl" data-id="element-506">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-507">
            {location.name}
          </h1>

          <div className="space-y-3 mb-8" data-id="element-508">
            <div className="flex items-start text-slate-200" data-id="element-509">
              <MapPin className="h-5 w-5 mr-3 flex-shrink-0 mt-1" data-id="element-510" />
              <span className="text-lg" data-id="element-511">{location.address}</span>
            </div>

            <div className="flex items-center text-slate-200" data-id="element-512">
              <Phone className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-513" />
              <a href={`tel:${location.phone.replace(/\D/g, '')}`} className="text-lg hover:text-white transition-colors" data-id="element-514">
                {location.phone}
              </a>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-515">
            <Button variant="primary" size="lg" className="shadow-lg" data-id="element-516">
              Get 2 Weeks Free
            </Button>
            <Button variant="outline" size="lg" className="bg-white/10 border-white text-white hover:bg-white hover:text-slate-900" onClick={scrollToContact} data-id="element-517">
              Contact This Location
            </Button>
          </div>
        </div>
      </div>
    </section>;
}